module.exports = __webpack_public_path__ + "static/media/CICLO_2_PROSPERIDAD_DIGITAL_2022.1986f769.jpg";